import URLSearchParams from '@ungap/url-search-params'
import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';
import 'chipta-libs/components/font-awesome.js';
import './list-item.js';


class EventDetails extends ChiptaElement {

  static get properties() {
    return {
      eventData: {type: Object}
    };
  }

  render() {

    return html`

      <list-item url=${this.ticketshopUrl}>

        ${this.imageEl}

        <div class="start-date">
          ${this.startDateEl}
        </div>

        <div class="name-details">

          <div class="name">${this.eventData.name}</div>

          ${this.locationEl}

        </div>

      </list-item>

    `;

  }

  get imageEl() {

    if (!this.eventData.events_overview_image) {
      return;
    }

    return html`
      <div class="image">
        <img src="${this.eventData.events_overview_image}" width="70" height="70" />
      </div>
    `;

  }

  get startDateEl() {

    const date = new Date(this.eventData.start_time);

    const dayText = date.toLocaleString('default', { weekday: 'short' }).toLowerCase();
    const monthText = date.toLocaleString('default', { month: 'short' }).toLowerCase();

    return html`
      <div class="date">${date.getDate()}</div>
      <div class="day-month-text">
        <div class="day-text">${dayText}</div>
        <div class="month-text">${monthText}</div>
      </div>
    `;

  }

  get locationEl() {

    if (!this.eventData.location) {
      return
    }

    return html`
      <div class="location">
        <font-awesome class="icon" icon="map-marker-alt"></font-awesome>
        ${this.eventData.location}
      </div>
    `;

  }

  static get styles() {

    return css`

      :host {
        display: block;
      }

      .image {
        display: flex;
        margin-right: 25px;
      }

      .start-date {
        display: flex;
        align-items: center;
        color: ${unsafeCSS(_themeData.text_color)};
        font-weight: 200;
      }

      .start-date .date {
        width: 50px;
        font-size: 44px;
        line-height: 44px;
        text-align: right;
      }

      .start-date .day-month-text {
        margin-left: 10px;
        width: 50px;
        text-align: left;
      }

      .name-details {
        flex: 1;
      }

      .name {
        color: ${unsafeCSS(_themeData.text_color)};
        font-size: 22px;
      }

      .location {
        margin-top: 5px;
        color: ${unsafeCSS(_themeData.light_text_color)};
      }

      .location .icon {
        display: inline-block;
        width: 15px;
        text-align: center;
      }

    `;

  }

  get ticketshopUrl() {
    return this.eventData.ticketshop_url + this.ticketshopUrlParams;
  }

  get ticketshopUrlParams() {

    const urlParams = new URLSearchParams(window.location.search);
    const copyParams = ['iframe', 'transparent-background'];
    let params = '';

    copyParams.forEach(param => {
      if (urlParams.has(param)) {
        params += '&' + param + '=' + urlParams.get(param);
      }
    });

    if (params) {
      return '?' + params.substr(1);
    }

    return '';

  }

}

customElements.define('event-details', EventDetails);
